<template>
    <client-page className="header--light">
        
        <sub-visual
        sh="인재채용"
        tabActive="채용절차"
        bg="/images/sub/visual/sv4-4.jpg">
        </sub-visual>

        <section class="section">
            <v-container>

                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">채용절차</h3>
                </div>

                <v-tabs class="tab tab--block mb-50 mb-md-70 mb-lg-80">
                    <v-tab class="tab__li" to="/recruitment/procedure">본사</v-tab>
                    <v-tab class="tab__li" to="/recruitment/procedure-branch">지점</v-tab>
                </v-tabs>

                <div class="mb-50 mb-lg-100">
                    <h5 class="bar-text d-flex flex-column flex-lg-row align-lg-center mb-30 mb-lg-20">
                        브랜드 홍보대사 & 펀드레이저 <span class="color-grey-7 page-text--sm d-inline-block mt-4 mt-0 ml-lg-20 font-weight-regular">본사를 제외한 전국 각 지점에서 활동하는 브랜드 홍보대사와 펀드레이저입니다.</span>
                    </h5>
                    <div class="pt-12 pt-lg-36 border-top border-color-black border-2 w-100">
                        <v-img src="/images/sub/recruitment/procedure/process2-mo.jpg" max-width="672" class="d-block d-md-none mb-16 mb-lg-30"></v-img>
                        <div class="process process5 d-none d-md-flex justify-space-between text-center mb-16 mb-lg-30">
                            <div data-aos="fade-up" data-aos-delay="100">
                                <div class="process-icon process-icon1-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon1-5.png" contain max-width="60"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    서류 지원
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="200">
                                <div class="process-icon process-icon2-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon2-5.png" contain max-width="60"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    1차 면접
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="300">
                                <div class="process-icon process-icon3-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon3-5.png" contain max-width="60"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    2차 실무 면접
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="400">
                                <div class="process-icon process-icon4-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon4-5.png" contain max-width="62"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    3차 지점장 면접
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="500">
                                <div class="process-icon process-icon4-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon5-5.png" contain max-width="80"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    최종 합격
                                </p>
                            </div>
                        </div>
                        <div class="w-100 bg-grey pa-20 px-md-30 py-md-20 mb-20">
                            <p class="font-size-12 font-size-lg-16 color-grey-7">
                                * 브랜드 홍보대사와 펀드레이저를 상시 모집합니다. <br>
                                * 채용절차는 지점에 따라 차이가 있을 수 있습니다. <br>
                                * 면접은 각 지점에서 진행합니다. (지점 상세 정보를 클릭하여, 지원을 희망하는 지점을 확인하세요.)
                            </p>
                        </div>
                        <div class="mb-30 mb-lg-60">
                            <arrow-btn tit="지점 상세 정보" color="primary" link="/location" type="to"></arrow-btn>
                        </div>
                        <div class="border-top border-color-light mb-50 mb-lg-80">
                            <underline-list tit="면접 전형">
                                기업과 직무에 대한 안내를 받습니다. <br>
                                지점장과 면접을 통해 지원자의 잠재 역량과 인성, 태도 등을 종합적으로 평가합니다.
                            </underline-list>
                            <underline-list tit="실무 면접">
                                직무 체험을 통해 나의 가능성을 확인합니다.
                            </underline-list>
                            <underline-list tit="최종 합격">
                                면접 후 최종 합격 시 개별 연락드립니다.
                            </underline-list>
                            <underline-list tit="접수 기간">
                                상시 모집
                            </underline-list>
                            <underline-list tit="접수 방법">
                                <a href="apply@salesworks.kr" target="_blank">apply@salesworks.kr</a> <br>
                                자기소개서와 이력서를 첨부하여, 이메일 제목에 "희망 지점"을 명시해주세요. <br>
                                또는 아래 채용사이트를 통해 지원할 수 있습니다.
                            </underline-list>
                        </div>
                        <div class="d-flex justify-center">
                            <arrow-btn tit="기업 상세정보" color="primary" link="https://www.saramin.co.kr/zf_user/company-info/view?csn=RWFleFZWa0VoWkNKVGNhQjlFSUdxZz09" type="href"></arrow-btn>
                        </div>
                    </div>
                </div>
                <div>
                    <h5 class="bar-text d-flex flex-column flex-lg-row align-lg-center mb-30 mb-lg-20">
                        어드민 <span class="color-grey-7 page-text--sm d-inline-block mt-4 mt-0 ml-lg-20 font-weight-regular">전국 각 지점에서 행정업무를 담당합니다.</span>
                    </h5>
                    <div class="pt-12 pt-lg-36 border-top border-color-black border-2 w-100">
                        <v-img src="/images/sub/recruitment/procedure/process1-mo.jpg" max-width="672" class="d-block d-md-none mb-16 mb-lg-30"></v-img>
                        <div class="process process4 d-none d-md-flex justify-space-between text-center mb-16 mb-lg-30">
                            <div data-aos="fade-up" data-aos-delay="100">
                                <div class="process-icon process-icon1-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon1-4.png" contain max-width="60"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    서류 지원
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="200">
                                <div class="process-icon process-icon2-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon2-4.png" contain max-width="60"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    1차 면접
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="300">
                                <div class="process-icon process-icon3-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon3-4.png" contain max-width="60"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    2차 면접
                                </p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="400">
                                <div class="process-icon process-icon4-4 mb-8 mb-lg-14">
                                    <v-img src="/images/sub/recruitment/procedure/process-icon4-4.png" contain max-width="80"></v-img>
                                </div>
                                <p class="page-text--sm font-weight-bold">
                                    최종 합격
                                </p>
                            </div>
                        </div>
                        <div class="w-100 bg-grey pa-20 px-md-30 py-md-20 mb-30 mb-lg-60">
                            <p class="font-size-12 font-size-lg-16 color-grey-7">
                                * 서류 합격 시 면접 일정을 개별 연락드립니다.  <br>
                                * 채용 절차는 지점에 따라 차이가 있을 수 있습니다.
                            </p>
                        </div>
                        <div class="border-top border-color-light mb-50 mb-lg-80">
                            <underline-list tit="서류 지원">
                                채용 사이트를 통해 이력서와 자기소개서를 제출합니다.
                            </underline-list>
                            <underline-list tit="면접 전형">
                                해당 지점의 지점장과 면접을 통해 지원자의 잠재 역량과 인성, 태도 등을 종합적으로 평가합니다.
                            </underline-list>
                            <underline-list tit="최종 합격">
                                면접 후 최종 합격 시 개별 연락드립니다.
                            </underline-list>
                        </div>
                        <div class="d-flex justify-center">
                            <arrow-btn tit="사람인에서 지원하기" color="primary" link="https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=RWFleFZWa0VoWkNKVGNhQjlFSUdxZz09" type="href" class="mr-4 mr-lg-10"></arrow-btn>
                            <arrow-btn tit="잡코리아에서 지원하기" color="primary" link="https://www.jobkorea.co.kr/Recruit/Co_Read/Recruit/C/appcokorea" type="href"></arrow-btn>
                        </div>
                    </div>
                </div>

            </v-container>
        </section>

    </client-page>

</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import UnderlineList from "@/components/client/sub/sub-underline-list.vue";
import ArrowBtn from "@/components/client/sub/arrow-btn.vue";

export default{
	components: {
        ClientPage,
        SubVisual,
        UnderlineList,
        ArrowBtn,
    },
    mounted() {
    },
    data () {
      return {
      }
    },
}
</script>

<style scoped>
.process{
    width: 100%;
    overflow: hidden;
    position: relative;
}

.process::before{
    content: "";
    display: block;
    position: absolute;
    height: 12px;
    width: 100%;
    top: calc(50% - 15px);
    left: 0;
    transform: translateY(-50%);
    background-image: url(/images/sub/recruitment/procedure/process-arrow4.png);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
}

.process4::before{
    background-image: url(/images/sub/recruitment/procedure/process-arrow4.png);
}

.process5::before{
    background-image: url(/images/sub/recruitment/procedure/process-arrow5.png);
}

.process-icon{
    position: relative;
    width: 126px;
    height: 126px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
}
.process-icon1-4{
    background-image: url(/images/sub/recruitment/procedure/process1-4.png);
}
.process-icon2-4{
    background-image: url(/images/sub/recruitment/procedure/process2-4.png);
}
.process-icon3-4{
    background-image: url(/images/sub/recruitment/procedure/process3-4.png);
}
.process-icon4-4{
    background-image: url(/images/sub/recruitment/procedure/process4-4.png);
}
.process-icon1-5{
    background-image: url(/images/sub/recruitment/procedure/process1-5.png);
}
.process-icon2-5{
    background-image: url(/images/sub/recruitment/procedure/process2-5.png);
}
.process-icon3-5{
    background-image: url(/images/sub/recruitment/procedure/process3-5.png);
}
.process-icon4-5{
    background-image: url(/images/sub/recruitment/procedure/process4-5.png);
}
.process-icon5-5{
    background-image: url(/images/sub/recruitment/procedure/process5-5.png);
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .process::before{
        top: calc(50% - 21px);
    }
    .process-icon{
        width: 170px;
        height: 170px;
    }
}
@media (min-width:1200px){
    .process-icon{
        width: 192px;
        height: 192px;
    }
}

</style>
